import React from "react";
import { DateInput } from "../../../controls";
import type { DateInputChangeEvent } from "../../../controls/DateInput/DateInput";
import { DateTime } from "luxon";

export interface HourSelectionProps {
  disabled?: boolean;
  hour: string;
  onChange: (hour: string) => void;
  timeIntervals?: number;
  includeTimes?: Date[];
  isClearable?: boolean;
}

const HourSelection: React.FC<HourSelectionProps> = ({
  disabled = false,
  hour,
  onChange,
  timeIntervals,
  includeTimes,
  isClearable,
}) => {
  const dateValue = DateTime.fromISO(hour);
  return (
    <DateInput
      data-testid={"hour-selection-dropdown"}
      showTimeSelect={true}
      // DateInput types `value` as string | null, but the runtime passes a
      // luxon DateTime here. Preserve existing behavior; cast to satisfy types.
      value={dateValue as unknown as string}
      timeIntervals={timeIntervals}
      includeTimes={includeTimes}
      onChange={(e: DateInputChangeEvent) => {
        const dateFromIso = DateTime.fromISO(e?.target?.value);
        onChange(dateFromIso.toFormat("HH:mm"));
      }}
      isClearable={isClearable}
      popoverClassName={"hour-selection-popover"}
      disabled={disabled}
    />
  );
};

export default HourSelection;
